import { LoggingService } from "../../ServiceDesk/sdServices/loggingSvc";

// @ngInject
export const logSessionStorage = ($window: ng.IWindowService, loggingService: LoggingService) => {
  // Do not log session information within an iframe
  if ($window != $window.top) {
    return;
  }

  let sessionStorageContents: string[] = [];
  Object.keys($window.sessionStorage).map((key: string) => {
    sessionStorageContents.push(`"${key}" -> "${$window.sessionStorage.getItem(key)}"`);
  });

  loggingService.logInfo(`Session storage contents: [${sessionStorageContents.join("; ")}]`);
};
